var CurrentUser = require("lib/account/CurrentUser");
var WhooosReadingServices = require("lib/web/WhooosReadingServices");

var Spinner = require("components/utility/Spinner");
var LoadingButton = require("components/utility/LoadingButton");
var ErrorDisplay = require("components/utility/ErrorDisplay")

require("technical/pending_sso_page.scss");

class PendingSSOPage extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			schoolOrg: null,

			username: "", password: "",

			mergeLoading: false, newAccountLoading: false
		};
	}


	///////////////////////////////////////////////////////
	// Deprecated - This was the old Passphrase system ////
	///////////////////////////////////////////////////////
	// passphraseChange(e) {
	// 	var code = e.target.value.trim().toUpperCase();
	// 	var studentList = _.find(this.state.schoolOrg.student_lists, function(sl) {
	// 		return sl.passphrase == code;
	// 	});
	// 	this.setState({ studentList: studentList });
	// }
	// confirmStudentList(e) {
	// 	$wr.nope(e)
	// 	var params = {
	// 		access_token: CurrentUser.getToken(),
	// 		student_list_id: this.state.studentList.id
	// 	}
	// 	var ssoURL = WhooosReadingServices.SsoServer.url("/select_student_list");
	// 	$wr.postJSON(ssoURL, params, function(response) {
	// 		if (response.success) {
	// 			window.location.reload();
	// 		} else {
	// 			window.wrNotifications.triggerDropDownNotification({
	// 				title: "Sorry!", text: response.error, 
	// 				icon: "exclamation-sign", type: "error" 
	// 			});
	// 		}
	// 	}.bind(this));
	// }
	// oldRender() {
	// 	if (this.state.schoolOrg == null) {
	// 		return (
	// 			<div className="pendingSSOPage container">
	// 				<Spinner placeholder={ true } scale={ 1.7 } />
	// 			</div>
	// 		);
	// 	}
	// 	if (this.state.schoolOrg.student_lists.length == 0) {
	// 		return (
	// 			<div className="pendingSSOPage container">
	// 				<header className="pageHeader">
	// 					<h1>Welcome to Whooo's Reading!</h1>
	// 				</header>
	// 				<div className="row">
	// 					<div className="col-sm-7 col-sm-offset-1">
	// 						<p>
	// 							Hi { CurrentUser.get().first_name }!
	// 						</p>
	// 						<p>
	// 							Your school isn't set up to use Whooo's Reading yet.
	// 							Please contact <a href="mailto:support@whooosreading.org">
	// 								support@whooosreading.org
	// 							</a> if you'd like to use Whooo's Reading.
	// 						</p>
	// 					</div>
	// 					<div className="col-sm-3">
	// 						<img src={ require("owls/owlfonso-green.png") }
	// 							className="img-responsive" />
	// 					</div>
	// 				</div>
	// 			</div>
	// 		);
	// 	}
	// 	if (CurrentUser.isAdmin()) {
	// 		if (this.state.studentList) {
	// 			var confirmDisplay = (
	// 				<div className="selectedStudentList">
	// 					<p>
	// 						Is this your class? <span className="confirmName">
	// 							{ this.state.studentList.name }
	// 						</span>
	// 					</p>
	// 					<p>
	// 						If not, check your code or contact your administrator.

	// 						<a href="#" className="btn buttonPrimary confirmButton"
	// 							onClick={ this.confirmStudentList }>
	// 							Confirm
	// 						</a>
	// 					</p>
	// 				</div>
	// 			);
	// 		} else {
	// 			var confirmDisplay = (
	// 				<div className="selectedStudentList empty" />
	// 			);
	// 		}
	// 	} else {
	// 		if (this.state.studentList) {
	// 			var confirmDisplay = (
	// 				<div className="selectedStudentList">
	// 					<a href="#" className="btn buttonPrimary studentConfirmButton" onClick={ this.confirmStudentList }>
	// 						Go!
	// 					</a>
	// 				</div>
	// 			);
	// 		} else {
	// 			var confirmDisplay = (
	// 				<div className="selectedStudentList empty" />
	// 			);
	// 		}
	// 	}

	// 	return (
	// 		<div className="pendingSSOPage container">
	// 			<header className="pageHeader">
	// 				<h1>{ this.state.schoolOrg.school.name }</h1>
	// 			</header>
	// 			<div className="row">
	// 				<div className="col-sm-7 col-sm-offset-1">
	// 					<p>
	// 						Welcome to Whooo's Reading { CurrentUser.get().first_name }! 
	// 					</p>
	// 					<p>
	// 						Enter your class code, which should be 4 letters and 4 numbers.
	// 						<br/>
	// 						<em className="smallText">(No need to worry about remembering this code, you'll only have to enter it once)</em>
	// 					</p>

	// 					<div className="inputSection">
	// 						<input className="form-control classCodeField"
	// 							onChange={ this.passphraseChange }
	// 							placeholder="Like this: AAAA4444" />
	// 						{ confirmDisplay }
	// 					</div>
	// 				</div>
	// 				<div className="col-sm-3">
	// 					<img src={ require("owls/owlfonso-green.png") }
	// 						className="img-responsive" />
	// 				</div>
	// 			</div>
	// 		</div>
	// 	);
	// }
	///////////////////////////////////////////////////////
	// End Deprecated /////////////////////////////////////
	///////////////////////////////////////////////////////

	onNewAccount(e) {
		$wr.nope(e)

		if (this.state.mergeLoading || this.state.newAccountLoading) {
			return;
		}
		this.refs.mergeErrors.reset();

		var params = {
			access_token: CurrentUser.getToken()
		}

		var ssoURL = WhooosReadingServices.SsoServer.url("/clever_sync");
		this.setState({ newAccountLoading: true });
		$wr.postJSON(ssoURL, params, (response) => {
			if (response.success) {
				window.location.reload()
			} else {
				console.error("Clever Sync Failed")
				console.log(response);
			}
		}, console.error);

	}

	onExistingAccountSubmit(e) {
		$wr.nope(e)

		if (this.state.mergeLoading || this.state.newAccountLoading) {
			return;
		}

		this.refs.mergeErrors.reset();

		var params = {
			access_token: CurrentUser.getToken(),
			merge_credentials: {
				username: this.state.username,
				password: this.state.password
			}
		}

		var ssoURL = WhooosReadingServices.SsoServer.url("/merge_accounts");
		this.setState({ mergeLoading: true });
		$wr.postJSON(ssoURL, params, (response) => {
			if (response.success) {
				CurrentUser.usernamePasswordAuthenticate(this.state.username, this.state.password, (success, errorText) => {
					if (success) {
						if (response.pending_onboarding) {
							window.location.reload();
						} else {
							window.location.href = "/roster?add_students=true"
						}
					} else {
						// Shouldn't happen
						this.refs.mergeErrors.setError(errorText);
						this.setState({ mergeLoading: false });
					}
				});

			} else {
				this.refs.mergeErrors.setError(response.error);
				this.setState({ mergeLoading: false });
			}
		}, console.error);

	}

	render() {
		if (this.state.schoolOrg == null) {
			return (
				<div className="pendingSSOPage container">
					<Spinner placeholder={ true } scale={ 1.7 } />
				</div>
			);
		}

		if (this.state.schoolOrg.school.name == "Whooo's Reading") {
			var schoolName = "Sync with Clever";
		} else {
			var schoolName = this.state.schoolOrg.school.name;
		}

		return (
			<div className="pendingSSOPage container">
				<header className="pageHeader">
					<h1>{ schoolName }</h1>
				</header>

				<p className="text-center">
					Add your students and sections from Clever to your Whooo's Reading account.
				</p>

				<div className="choice">
					<div className="option">
						<p className="opHeader">Create a new account?</p>
						<p>
							This will add your students and sections to a new Whooo's Reading
							account.
						</p>
						<LoadingButton className="btn buttonPrimary" text="Create Account"
							loading={ this.state.newAccountLoading } onClick={ this.onNewAccount } />	
					</div>
					<div className="option small">
						<p className="bigOr">OR</p>
					</div>
					<div className="option">
						<p className="opHeader">Merge into an existing account?</p>
						<p>
							This will merge your students and sections into an existing Whooo's Reading account.
						</p>
						<ErrorDisplay ref="mergeErrors" />
						<div className="accountFields">
							<form onSubmit={ this.onExistingAccountSubmit }>
								<input className="form-control" placeholder="Username or email"
									value={ this.state.username }
									onChange={ (e) => { this.setState({ username: e.target.value }) } } />

								<input className="form-control" placeholder="Password"
									type="password" 
									value={ this.state.password }
									onChange={ (e) => { this.setState({ password: e.target.value }) } } />

								<LoadingButton className="btn buttonPrimary" text="Merge Account"
									loading={ this.state.mergeLoading } />	
							</form>
						</div>
					</div>
				</div>
			</div>
		)
	}

	componentDidMount() {
		var embeds = "user.pending_primary_school_org,school_org.school,school_org.active_student_lists,student_list.passphrase";

		CurrentUser.api().getUser(CurrentUser.get().id, { embed: embeds }, $wr.apiHandler(function(response) {
			this.setState({ schoolOrg: response.user.pending_primary_school_org })
		}.bind(this)));
	}
};

PendingSSOPage.propTypes = PageStrictPropTypes({
});

module.exports = PendingSSOPage;



// WEBPACK FOOTER //
// ./modules/components/technical/PendingSSOPage.js